// extracted by mini-css-extract-plugin
export var filterIncDec = "_ds-0";
export var leftBorder = "_ds-1";
export var rightBorder = "_ds-2";
export var stringInput = "_ds-3";